import { render, staticRenderFns } from "./StatW25CNY.vue?vue&type=template&id=e15e8102&"
import script from "./StatW25CNY.vue?vue&type=script&lang=js&"
export * from "./StatW25CNY.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports